import { Dialog } from '@mui/material'
import { ModalTypes } from '@dtx-company/inter-app/src/redux/slices/modal'
import { ProfileMenu } from '../../../bottom/ProfileMenu/ProfileMenu'
import { theme } from '@dtx-company/design-system/src'
import { useModal } from '@dtx-company/inter-app/src/redux/slices/utils'
import { useV3NavigationTopOffset } from '../../../side/v3/hooks'
import React from 'react'

export const ProfileMenuDialog: React.FC = () => {
  const { setClose, modalOpen } = useModal(ModalTypes.DESKTOP_PROFILE_MENU_MODAL)
  const DIALOG_RIGHT_OFFSET = 16
  const ARROW_HEIGHT = 10
  const DIALOG_ARROW_RIGHT_OFFSET = 42
  const { sideNavTopOffset: dialogTopOffset } = useV3NavigationTopOffset()
  return (
    <Dialog
      data-testid="desktop-profile-menu-dialog"
      open={modalOpen}
      onClose={setClose}
      hideBackdrop
      sx={{
        position: 'fixed',
        top: dialogTopOffset,
        right: DIALOG_RIGHT_OFFSET,
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
          justifyContent: 'flex-end',
          // Top Arrow (carrot) styling:
          '&::before,&::after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            width: 0,
            height: 0,
            borderStyle: 'solid'
          },
          '&::after': {
            left: `calc(100% - ${DIALOG_ARROW_RIGHT_OFFSET}px)`,
            top: `-${ARROW_HEIGHT * 2}px`,
            borderColor: `transparent transparent ${theme.palette.background.paper} transparent`,
            borderWidth: `${ARROW_HEIGHT}px`
          },
          '&::before': {
            left: `calc(100% - ${DIALOG_ARROW_RIGHT_OFFSET + 2}px)`,
            top: `-${ARROW_HEIGHT * 2 + 4}px`,
            borderColor: `transparent transparent ${theme.palette.border.divider} transparent`,
            borderWidth: `${ARROW_HEIGHT + 2}px`
          }
        },
        dropShadow: 1,
        zIndex: 'modal'
      }}
      PaperProps={{
        sx: {
          width: theme.spacing(74),
          margin: 0,
          borderWidth: theme.spacing(0, 0.25, 0.25, 0.25),
          borderStyle: 'solid',
          borderColor: 'border.divider',
          padding: theme.spacing(4, 0, 0, 0)
        }
      }}
    >
      <ProfileMenu isDesktop />
    </Dialog>
  )
}
